import React, { useState, useEffect } from "react";
import { Input } from "./input";

const InvestmentInput = ({initalValue=500,valueUpdated}) => {
  const [inputValue, setInputValue] = useState(initalValue);
  const [investmentAmount, setInvestmentAmount] = useState(initalValue); // Assuming default is 100

  useEffect(() => {
    // Debounce effect with a timeout of 500ms
    const handler = setTimeout(() => {
      if (inputValue >= 100) {
        setInvestmentAmount(inputValue);
      }
    }, 500);

    return () => {
      clearTimeout(handler); // Clear the timeout if the input value changes within 500ms
    };
  }, [inputValue]);

  useEffect(() => {
    valueUpdated(investmentAmount);
  }, [investmentAmount])
  

  const handleChange = (e) => {
    if (isNaN(e.target.value)) {
      alert("Please enter a valid number");
      return;
    }
   
    setInputValue(parseFloat(e.target.value)); // Update the input value
  };

  return (
    <div className="flex flex-row">
      <h6 className="mr-2 text-center flex items-center">R</h6>
      <Input
        onChange={handleChange}
        value={inputValue}
        type="number"
        placeholder={"Enter Amount"}
        className="md:w-1/4 w-full"
      />
    </div>
  );
};

export default InvestmentInput;